import { useContext } from 'react'
import useSeti from './useSeti'
import BootstrapDataContext from '../../context/BootstrapDataContext'
import { AMENITIES } from '../SearchForm/constants'
import { SEM_SEARCH_TYPE } from '../Hotels/types'

export default function useSEMSearchCheapKeywordExperiment(
  semSearchParam: SEM_SEARCH_TYPE
) {
  const {
    signInStatus: { signedIn, passiveSignIn }
  } = useContext(BootstrapDataContext)
  const isSignedIn = signedIn || passiveSignIn
  const runCheapKeywordExperiment = !isSignedIn && semSearchParam === 'CHEAP'
  const semSearchCheapKeywordExpValue = useSeti(
    'SEM_HP_HOTELS_CHEAP_HEADING',
    runCheapKeywordExperiment
  ) as keyof typeof AMENITIES.CHEAP
  return runCheapKeywordExperiment
    ? AMENITIES.CHEAP[semSearchCheapKeywordExpValue] || null
    : null
}
